<template>
  <div class="max-w-3xl mx-auto px-2 md:px-0">
    <div class="flex flex-col gap-2 md:gap-4">
      <div class="flex items-center gap-2 text-xs font-medium md:hidden">
        <div class="w-1 h-1 bg-green-500 rounded-full animate-pulse"></div>
        <span class="text-black dark:text-black-400 text-[10px]">Live Updates</span>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-4">
        <div v-for="(stat, index) in stats" :key="index"
          class="relative overflow-hidden bg-white dark:bg-gray-800 rounded-lg md:rounded-xl p-2.5 md:p-4 shadow md:shadow-lg hover:shadow-lg md:hover:shadow-xl transition-all duration-300 group"
        >
          <div class="flex items-center md:items-start justify-between">
            <div class="relative z-10 flex md:block items-center gap-3 md:gap-0">
              <div class="flex items-center gap-1.5 md:gap-2 md:mb-2">
                <div class="p-1.5 md:p-2 bg-primary/10 rounded">
                  <Icon 
                    :name="stat.icon" 
                    class="w-4 h-4 md:w-5 md:h-5 text-primary"
                  />
                </div>
                <div class="hidden md:block w-1.5 h-1.5 bg-black rounded-full animate-ping"></div>
              </div>
              <div class="flex flex-col md:block">
                <p class="text-[10px] md:text-xs text-gray-600 dark:text-gray-400 md:mb-0.5 order-2 md:order-none">{{ stat.label }}</p>
                <div class="flex items-baseline gap-0.5 md:gap-1">
                  <span class="text-lg md:text-2xl font-bold text-gray-900 dark:text-white">{{ stat.value }}</span>
                  <span class="text-[10px] md:text-xs text-primary font-medium">+</span>
                </div>
              </div>
            </div>
          </div>
          <div class="absolute -right-3 -bottom-3 md:-right-4 md:-bottom-4 w-12 h-12 md:w-16 md:h-16 bg-primary/5 rounded-full transition-transform duration-300 group-hover:scale-150"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { find } = useStrapi()

const totalEvents = ref(0)
const totalMembers = ref(0)
const totalArticles = ref(0)

const stats = computed(() => [
  { icon: 'heroicons:calendar', value: totalEvents.value, label: 'Events' },
  { icon: 'heroicons:users', value: totalMembers.value, label: 'Members' },
  { icon: 'heroicons:newspaper', value: totalArticles.value, label: 'Categories' }
])

onMounted(async () => {
  try {
    const [events, members, articles] = await Promise.all([
      find('aa-events', { pagination: { limit: 1 } }),
      find('aa-users', { pagination: { limit: 1 } }),
      find('aa-tags', { pagination: { limit: 1 } })
    ])
    
    totalEvents.value = events.meta.pagination.total
    totalMembers.value = members.meta.pagination.total
    totalArticles.value = articles.meta.pagination.total
  } catch (error) {
    console.error('Error fetching stats:', error)
  }
})
</script>